import { Link } from "design-system/components/primitives/link/link";
import { EditAttributes } from "design-system/types/types";

export interface ArticleFooterContributorInfoProps {
  isAdditionalCredits?: boolean;
  name: string;
  link?: string;
  type?: string;

  editAttributes?: {
    name?: EditAttributes;
    email?: EditAttributes;
    phone?: EditAttributes;
    type?: EditAttributes;
  };
}

export function ArticleFooterContributorInfo({
  isAdditionalCredits,
  name,
  link,
  type,
  editAttributes,
}: ArticleFooterContributorInfoProps) {
  return (
    <address className="hbs-article-footer__author">
      <span {...editAttributes?.name}>
        {link ? <Link href={link}>{name}</Link> : name}
      </span>
      {isAdditionalCredits && (
        <span {...editAttributes?.type}>{type ? ` - ${type}` : ""}</span>
      )}
    </address>
  );
}
